<template lang="pug">
div
  //- 非台湾地区省自动选中
  .form-layer-item-body.regions-item(v-if="area != '台湾'")
    select(v-if="checkedPayment == 0" name='province', required v-model="province" @invalid="errorHandle")
      option(:value="areaProvince" selected) {{areaProvince}}
  //- 台湾地区选择省市区
  .form-layer-item-body.regions-item(v-if="area == '台湾'")
    select(v-if="checkedPayment == 0" name='province', required v-model="province" @invalid="errorHandle")
      option(value="") 省
      option(value="台湾") 台湾
    select(name='city', required v-model="selectedCityIndex" @invalid="errorHandle")
      option(value='') 市
      option(v-for="(city, ci) of area_city" :key="ci" :value="ci") {{city}} 
    
    select(name='district', required v-model="selectedDistrictIndex" @invalid="errorHandle")
      option(value="") 區!
      option(v-for="(district, di) of area_district[selectedCityIndex]" :value="di") {{district}}
    select(v-if="checkedPayment != 0 && selectedCityIndex !== '' && selectedDistrictIndex !== ''" name='store_name' v-model="selectedStoreAddress" required @invalid="errorHandle")
      option(value='')
      option(v-for="(store, si) of area_store[selectedCityIndex][selectedDistrictIndex]" :key="si" :value="si") {{store.Address || store.addr}}
    
</template>

<script>
import area_family from '../assets/area_family.js'
import area_711 from '../assets/area_711.js'
import area_base from '../assets/area_family.js'
export default {
  props: ['checkedPayment', 'area', 'areaProvince', 'locale'],
  data() {
    return {
      province: '台湾',
      selectedProvinceIndex: 0,
      selectedProvince: '0',
      selectedCityIndex: '',
      selectedCity: '',
      selectedDistrictIndex: '',
      selectedDistrict: '',
      selectedStoreAddress: ''
    }
  },
  computed: {
    area_city() {
      switch(this.checkedPayment) {
        case 1: // 711
          return area_711.area_city
        case 2: // 全家
          return area_family.area_city
        default: 
          return area_base.area_city
      }
    },
    area_district() {
      switch(this.checkedPayment) {
        case 1: // 711
          return area_711.area_district
        case 2: // 全家
          return area_family.area_district
        default: // 货到付款
          return area_base.area_district
      }
    },
    area_store() {
      switch(this.checkedPayment) {
        
        case 1: // 711
          return area_711.area_store
        case 2: // 全家
          return area_family.area_store
        default: // 货到付款
          return area_base.area_store
      }
    }
  },
  watch: {
    areaProvince(ap) {
      console.log(ap)
      this.province = ap
    },
    checkedPayment() {
      this.selectedProvinceIndex = 0
      this.selectedCityIndex = ''
      this.selectedDistrictIndex = ''
      this.selectedStoreAddress = ''
    },
    selectedCityIndex(ni) {
      console.log(ni)
      this.selectedCity = this.area_city[ni]
      this.selectedDistrictIndex = ''
      this.$emit('change', {})
    },
    selectedDistrictIndex(ni) {
      console.log(ni)
      this.selectedDistrict = this.area_district[this.selectedCityIndex][ni]
      this.selectedStoreAddress = ''
      if (this.checkedPayment === 0) {
        this.$emit('change', {
          province: this.province,
          city: this.selectedCity,
          district: this.selectedDistrict,
        })
      } else {
        this.$emit('change', {})
      }
    },
    selectedStoreAddress(sa) {
      if (sa === '') {
        return
      }
      let checkedStore = this.area_store[this.selectedCityIndex][this.selectedDistrictIndex][sa]
      let store = {}
      switch(this.checkedPayment) {
        case 1: // 711
          store = {
            name: checkedStore.POIName,
            address: checkedStore.Address,
            id: checkedStore.POIID,
            tel: checkedStore.Telno
          }
          break
        case 2: //全家
          store = {
            name: checkedStore.name,
            address: checkedStore.addr,
            id: checkedStore.pkey,
            tel: checkedStore.tel
          }
          break
      }
      let fullAddress = store.address
      console.log(fullAddress)
      this.$emit('change', {
        store,
        province: this.province,
        city: this.selectedCity,
        district: this.selectedDistrict,
        fullAddress
      })
    }
  },
  methods: {
    errorHandle(e) {
      console.log(e.target.validity)
      if (e.target.validity.valueMissing) {
        e.target.setCustomValidity(this.locale.missingValue)
        return
      } else {
        e.target.setCustomValidity('')
      }

      if (e.target.validity.tooShort || e.target.validity.tooLong) {
        e.target.setCustomValidity(this.locale.lengthError)
        return
      } else {
        e.target.setCustomValidity('')
      }

      if (e.target.validity.typeMismatch) {
        e.target.setCustomValidity(this.locale.mismatch)
        return
      } else {
        e.target.setCustomValidity('')
      }
    },
  },
  mounted() {
  }
}
</script>